module.exports = __webpack_public_path__ + "img/blue75.d87e5250.png";